import { render, staticRenderFns } from "./BridgeAlertRules.vue?vue&type=template&id=aef6caa4&scoped=true"
import script from "./BridgeAlertRules.vue?vue&type=script&lang=js"
export * from "./BridgeAlertRules.vue?vue&type=script&lang=js"
import style0 from "./BridgeAlertRules.vue?vue&type=style&index=0&id=aef6caa4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aef6caa4",
  null
  
)

export default component.exports